var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchx2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 22.08,
    height: 14.4,
    viewBox: "0 0 22.079999 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path403"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath405"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path405"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath407"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path407"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath409"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path409"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath411"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path411"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path413"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath415"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path415"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath417"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path417"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath419"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path419"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath421"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path421"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath423"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path423"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath425"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path425"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath427"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path427"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath429"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path429"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path431"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath433"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path433"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath435"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "rotate(90,4032,1437.5)",
    id: "path435"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-oc2",
    transform: "translate(-172.5867,-355.30667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path402",
    d: "m 2617,5467 v 4 -8 z m 0,4 v -8 13 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    d: "m 2617,5463 v 13 l -2,-18 z m 0,13 -2,-18 v 22 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    d: "m 2615,5458 v 22 l -2,-25 z m 0,22 -2,-25 v 28 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    d: "m 2613,5455 v 28 l -3,-31 z m 0,28 -3,-31 v 35 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    d: "m 2610,5452 v 35 l -4,-38 z m 0,35 -4,-38 v 40 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "m 2606,5449 v 40 l -4,-42 z m 0,40 -4,-42 v 44 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    d: "m 2602,5447 v 44 l -4,-45 z m 0,44 -4,-45 v 46 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "m 2598,5446 v 46 l -4,-47 z m 0,46 -4,-47 v 48 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    d: "m 2594,5445 v 48 l -5,-47 z m 0,48 -5,-47 v 46 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path420",
    d: "m 2589,5446 v 46 l -4,-45 z m 0,46 -4,-45 v 44 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    d: "m 2585,5447 v 44 l -4,-42 z m 0,44 -4,-42 v 40 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    d: "m 2581,5449 v 40 l -3,-37 z m 0,40 -3,-37 v 35 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "m 2578,5452 v 35 l -3,-32 z m 0,35 -3,-32 v 28 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path428",
    d: "m 2575,5455 v 28 l -2,-25 z m 0,28 -2,-25 v 22 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path430",
    d: "m 2573,5458 v 22 l -2,-17 z m 0,22 -2,-17 v 13 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path432",
    d: "m 2571,5463 v 13 l -1,-9 z m 0,13 -1,-9 v 4 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path434",
    d: "M 23.5,0 C 23.5,12.97869 12.97869,23.5 0,23.5 -12.97869,23.5 -23.5,12.97869 -23.5,0 c 0,-12.97869 10.52131,-23.5 23.5,-23.5 12.97869,0 23.5,10.52131 23.5,23.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,183.54667,359.54667)",
    clipPath: "url(#clipPath435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path436",
    d: "m 2572,5479 -38,18 v 38",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path437",
    d: "m 2572,5459 -38,-18 v -38",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchx2);
export default __webpack_public_path__ + "static/media/switchx2.4cd21ad5191c71063c597b8205285636.svg";
export { ForwardRef as ReactComponent };